import React from "react";
import { moment } from "../common/common";
import ReactSimpleRange from "react-simple-range";

import { formatPrice } from "../common/common";
import { commonErr } from "../common/errors";
import { LoadingInline, LoadingOverlay } from "../common/loading";
import { getCarSetting, updateCar, getCarCalendar } from "../../model/car";
import { MessageBox, MessageLine } from "../common/messagebox";

export default class CarSettingPriceWD extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",
		};
	}

	init = (car) => {
		getCarCalendar(car.id, undefined, undefined, 'cs').then((carCalendarResp) => {
			if (carCalendarResp.data.error >= commonErr.SUCCESS) {
				getCarSetting({
					carId: car.id,
				}).then((carSettingResp) => {
					const wdSetting = carSettingResp.data.data.wdSetting;
					const wdCalendar = carCalendarResp.data.data.wdCalendar;

					if (wdCalendar) {
						this.setState({
							err: carSettingResp.data.error,
							errMsg: carSettingResp.data.errorMessage,

							basePrice: wdCalendar.basePrice,
							extraKMFee: wdSetting.extraKMFee,
							extraHourFee: wdSetting.extraHourFee,

							time: moment(),
							car,
							setting: wdSetting,
						});
					}
				});
			}
		});
	};

	componentDidMount() {
		const car = this.props.car;
		this.init(car);
	}

	componentWillReceiveProps(props) {
		const car = props.car;
		this.init(car);
	}

	// onBasePriceChange = (event) => {
	//     if (isNaN(event.target.value)) {
	//         return;
	//     }
	//     this.setState({
	//         basePrice: event.target.value * 1000
	//     });
	// }

	onBasePriceChange = (range) => {
		this.setState({
			basePrice: range.value,
		});
	};

	// onExtraKMFeeChange = (event) => {
	//     if (isNaN(event.target.value)) {
	//         return;
	//     }
	//     this.setState({
	//         extraKMFee: event.target.value * 1000
	//     });
	// }

	onExtraKMFeeChange = (range) => {
		this.setState({
			extraKMFee: range.value,
		});
	};

	// onExtraHourFeeChange = (event) => {
	//     if (isNaN(event.target.value)) {
	//         return;
	//     }
	//     this.setState({
	//         extraHourFee: event.target.value * 1000
	//     });
	// }

	onExtraHourFeeChange = (range) => {
		this.setState({
			extraHourFee: range.value,
		});
	};

	hideMessageBox = () => {
		this.setState({
			updateErrMsg: "",
		});
	};

	// isValid = () => {
	//     var errMsg = ""

	//     // check terms for base price, extra fee
	//     if (!this.state.basePrice || this.state.basePrice <= 0) {
	//         errMsg = "Bạn chưa chọn giá cơ bản cho xe."
	//     } else if (this.state.basePrice > this.state.setting.priceDailyMax || this.state.basePrice < this.state.setting.priceDailyMin) {
	//         errMsg = `Giá cơ bản không hợp lệ. Giá cơ bản cho phép trong khoản từ ${formatPrice(this.state.setting.priceDailyMin)} đến ${formatPrice(this.state.setting.priceDailyMax)}.`
	//     } else if (this.state.extraKMFee > this.state.setting.extraKMFeeMax || this.state.extraKMFee < this.state.setting.extraKMFeeMin) {
	//         errMsg = `Phí phụ thu vượt km không hợp lệ. Phí phụ thu vượt km cho phép trong khoản từ ${formatPrice(this.state.setting.extraKMFeeMin)} đến ${formatPrice(this.state.setting.extraKMFeeMax)}.`
	//     } else if (this.state.extraHourFee > this.state.setting.extraHourFeeMax || this.state.extraHourFee < this.state.setting.extraHourFeeMin) {
	//         errMsg = `Phí phụ thu vượt giờ không hợp lệ. Phí phụ thu vượt giờ cho phép trong khoản từ ${formatPrice(this.state.setting.extraHourFeeMin)} đến ${formatPrice(this.state.setting.extraHourFeeMax)}.`
	//     }

	//     return errMsg;
	// }

	updateCarInfo = () => {
		// const errMsg = this.isValid();
		// if (errMsg !== "") {
		//     this.setState({
		//         err: commonErr.FAIL,
		//         updateErrMsg: errMsg
		//     });
		//     return;
		// }

		const { basePrice, extraKMFee, extraHourFee } = this.state;

		this.setState({
			err: commonErr.LOADING,
		});
		updateCar(this.state.car.id, {
			wdBasePrice: basePrice,
			wdExtraKMFee: extraKMFee,
			wdExtraHourFee: extraHourFee,

			withDriver: true, //set to update data in mode with driver
		}).then((updateCarResp) => {
			this.setState({
				err: updateCarResp.data.error,
				updateErrMsg: updateCarResp.data.errorMessage,
			});
		});
	};

	render() {
		var content;
		if (this.state.err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else if (!this.state.car || !this.state.setting) {
			content = <MessageLine message="Không tìm thấy thông tin." />;
		} else {
			const { basePrice, extraKMFee, extraHourFee, setting } = this.state;
			content = (
				<div className="content">
					<div className="content-container">
						{this.state.err === commonErr.LOADING && <LoadingOverlay />}
						{this.state.updateErrMsg && this.state.updateErrMsg !== "" && (
							<MessageBox
								error={this.state.err}
								message={this.state.updateErrMsg}
								show={this.state.updateErrMsg && this.state.updateErrMsg !== ""}
								hideModal={this.hideMessageBox}
							/>
						)}

						<h3>Đơn giá thuê mặc định</h3>
						<p className="fl">
							<span className="note">
								Đơn giá áp dụng cho tất cả các ngày. Bạn có thuể tuỳ chỉnh giá khác cho các ngày đặc biệt (cuối tuần,
								lễ, tết...) trong mục quản lý xe sau khi đăng kí.
							</span>
						</p>
						<div className="space m"></div>
						<div className="space m"></div>
						<div className="space m"></div>

						{/* 1 */}
						{/* 
                    <div className="col-1">
                        <div className="form-default">
                            <div className="line-form">

                                <label className="label">Giá cơ bản (Lộ trình 8h/100km)</label>
                                <div className="wrap-input-label d-flex">
                                    <div className="wrap-input">
                                        <input type="text" value={basePrice / 1000} onChange={this.onBasePriceChange} />
                                    </div>
                                    <span className="phay"> K</span>
                                </div>
                                <div className="space m"></div>

                                <p className="pl">
                                    <span className="note">Giá đề xuất: {formatPrice(setting.basePriceRecommend)}</span>
                                </p>
                            </div>
                        </div>
                    </div> */}

						<div className="col-1">
							<div className="form-default">
								<div className="line-form">
									<label className="label">Giá cơ bản (Lộ trình 8 tiếng/100km)</label>
									<div className="range-slider">
										<ReactSimpleRange
											step={1000}
											min={setting.priceDailyMin}
											max={setting.priceDailyMax}
											value={basePrice}
											sliderSize={14}
											thumbSize={16}
											label={false}
											trackColor={"#5fcf86"}
											thumbColor={"#141414"}
											onChange={this.onBasePriceChange}
										/>
									</div>
									<span style={{ float: "right", fontSize: "14px" }}>{basePrice / 1000}K</span>
									<div className="space m" />
									<p className="pl">
										<span className="note">Giá đề xuất: {formatPrice(setting.basePriceRecommend)}</span>
									</p>
								</div>
							</div>
						</div>

						{/* 2 */}
						{/* 
                    <div className="col-2">
                        <div className="form-default">
                            <div className="line-form">

                                <label className="label">Phí phụ thu vượt km</label>
                                <div className="wrap-input-label d-flex">
                                    <div className="wrap-input">
                                        <input type="text" value={extraKMFee / 1000} onChange={this.onExtraKMFeeChange} />
                                    </div>
                                    <span className="phay"> K</span>
                                </div>
                                <div className="space m"></div>

                                <p className="pl">
                                    <span className="note">Giá đề xuất: {formatPrice(setting.extraKMFeeRecommend)}</span>
                                </p>
                            </div>
                        </div>
                    </div>
 */}

						<div className="col-2">
							<div className="form-default">
								<div className="line-form">
									<label className="label">Phí phụ thu vượt km</label>

									<div className="range-slider">
										<ReactSimpleRange
											step={1000}
											min={setting.extraKMFeeMin}
											max={setting.extraKMFeeMax}
											value={extraKMFee}
											sliderSize={14}
											thumbSize={16}
											label={false}
											trackColor={"#5fcf86"}
											thumbColor={"#141414"}
											onChange={this.onExtraKMFeeChange}
										/>
									</div>
									<span style={{ float: "right", fontSize: "14px" }}>{extraKMFee / 1000}K</span>
									<div className="space m" />
									<p className="pl">
										<span className="note">Giá đề xuất: {formatPrice(setting.extraKMFeeRecommend)}</span>
									</p>
								</div>
							</div>
						</div>

						{/* 3 */}

						{/* <div className="col-1">
                        <div className="form-default">
                            <div className="line-form">

                                <label className="label">Phí phụ thu vượt giờ</label>
                                <div className="wrap-input-label d-flex">
                                    <div className="wrap-input">
                                        <input type="text" value={extraHourFee / 1000} onChange={this.onExtraHourFeeChange} />
                                    </div>
                                    <span className="phay"> K</span>
                                </div>
                                <div className="space m"></div>

                                <p className="pl">
                                    <span className="note">Giá đề xuất: {formatPrice(setting.extraHourFeeRecommend)}</span>
                                </p>
                            </div>
                        </div>
                    </div> */}

						<div className="col-1">
							<div className="form-default">
								<div className="line-form">
									<label className="label">Phí phụ thu vượt giờ</label>

									<div className="range-slider">
										<ReactSimpleRange
											step={1000}
											min={setting.extraHourFeeMin}
											max={setting.extraHourFeeMax}
											value={extraHourFee}
											sliderSize={14}
											thumbSize={16}
											label={false}
											trackColor={"#5fcf86"}
											thumbColor={"#141414"}
											onChange={this.onExtraHourFeeChange}
										/>
									</div>
									<span style={{ float: "right", fontSize: "14px" }}>{extraHourFee / 1000}K</span>
									<div className="space m" />
									<p className="pl">
										<span className="note">Giá đề xuất: {formatPrice(setting.extraHourFeeRecommend)}</span>
									</p>
								</div>
							</div>
						</div>

						<div className="space m clear"></div>
						{/* <a className="link-calendar" onClick={this.updateCarInfo} href={`/carsetting/${this.state.car.id}#calendarsetting`}><i className="ic ic-setting-calendar"></i>Tùy chỉnh giá theo lịch </a> */}
						<div className="line"></div>
						<a className="btn btn-primary btn--m" onClick={this.updateCarInfo}>
							Lưu thay đổi
						</a>
					</div>
				</div>
			);
		}

		return content;
	}
}
